((Drupal) => {
  // eslint-disable-next-line no-param-reassign
  Drupal.behaviors.chip = {
    attach(context) {
      // Use prefixed BEM classes to avoid collision with Pattern Lab version
      context.querySelectorAll('.c-chip--dismissable').forEach((chip) => {
        // Prevent double initialization
        if (chip.dataset.chipInitialized) {
          return;
        }
        // eslint-disable-next-line no-param-reassign
        chip.dataset.chipInitialized = 'true';

        chip.addEventListener('click', () => {
          chip.classList.toggle('c-chip--dismissed');
        });
      });
    },

    detach(context, settings, trigger) {
      // Cleanup on unload
      if (trigger === 'unload') {
        context.querySelectorAll('.c-chip--dismissable').forEach((chip) => {
          // eslint-disable-next-line no-param-reassign
          delete chip.dataset.chipInitialized;
        });
      }
    },
  };
})(Drupal);
